import axios from 'utils/axios';

export const updateAnyDoctorAvailability = (doctorId: string, availability: string): Promise<any> =>
  axios.put(`/api/v1/doctors/${doctorId}/availability`, { availability });
